import {graphql} from 'react-relay';
import {Disposable, Environment} from 'relay-runtime';
import Util from '../forecast-app/shared/util/util';
import {trackEvent} from '../tracking/amplitude/TrackingV2';
import {trackAndCommitMutation} from '../tracking/amplitude/TrackMutation';
import type {
	CreateClientContactMutation,
	CreateClientContactMutation$data as CreateClientContactMutationResponse,
	CreateClientContactMutation$variables,
} from './__generated__/CreateClientContactMutation.graphql';

type CreateClientContactInput = CreateClientContactMutation$variables['input'];

const mutation = graphql`
	mutation CreateClientContactMutation($input: CreateClientContactInput!) {
		createClientContact(input: $input) {
			clientContact {
				cursor
				node {
					id
					firstName
					lastName
					email
					jobTitle
					phone
					status
					isGuestUser
					client {
						id
						name
					}
					company {
						id
						name
					}
					projects {
						edges {
							node {
								id
								name
							}
						}
					}
				}
			}
		}
	}
`;

export type CreateClientContactCommitInput = Omit<CreateClientContactInput, 'csrfToken' | 'socketClientId'>;

function commit(
	environment: Environment,
	input: CreateClientContactCommitInput,
	onSuccess?: (response: CreateClientContactMutationResponse) => void,
	onError?: (error: Error) => void
): Disposable {
	return trackAndCommitMutation<CreateClientContactMutation>(environment, {
		mutation,
		variables: {
			input: {
				...input,
				csrfToken: Util.getCsrfValue(),
				socketClientId: Util.getClientId(),
			},
		},
		onCompleted: (response: CreateClientContactMutationResponse) => {
			trackEvent('Client Contact', 'Created');
			onSuccess?.(response);
		},
		onError,
	});
}

export default {commit};
